import { createMergedBlockSelector } from "../../selectors";
import { getNewsBlock } from "../selectors";
var getNewsData = createMergedBlockSelector(getNewsBlock);
export var getNewsTitle = function getNewsTitle(state) {
  return getNewsData(state).title;
};
export var getNewsSubTitle = function getNewsSubTitle(state) {
  return getNewsData(state).subTitle;
};
export var getNewsLink = function getNewsLink(state) {
  return getNewsData(state).subTitleLink;
};
export var getNewsCardsListItems = function getNewsCardsListItems(state) {
  return getNewsData(state).items;
};